import breakpointsJson from './lib/breakpoints.json'
import colorsJson from './lib/colors.json'
import { ReactComponent as Defs } from './lib/defs.svg'
const { breakpoints } = breakpointsJson
const { colors } = colorsJson

export * from './lib/components'
export * from './lib/legacy'
export * from './lib/utils'
export * from './lib/content'
export { breakpoints, Defs, colors }
